import { render, staticRenderFns } from "./support-ticket-detail.vue?vue&type=template&id=375d284f"
import script from "./support-ticket-detail.vue?vue&type=script&lang=js"
export * from "./support-ticket-detail.vue?vue&type=script&lang=js"
import style0 from "./support-ticket-detail.vue?vue&type=style&index=0&id=375d284f&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports